export default "__VITE_ASSET__wduKnnAJ__"